import React, { useEffect, useState } from "react";
import  "./CircularTimer.css";

interface CircularTimerProps {
    duration: number; // Total duration in seconds
}

const CircularTimer: React.FC<CircularTimerProps> = ({ duration }) => {
    const [timeLeft, setTimeLeft] = useState(duration);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const percentage = (timeLeft / duration) * 100;

    return (
        <div className="circular-timer ">
            <svg width="100" height="100" viewBox="0 0 100 100">
                <circle
                    cx="50"
                    cy="50"
                    r="45"
                    stroke="transparent"
                    strokeWidth="5"
                    fill="none"
                />
                <circle
                    cx="50"
                    cy="50"
                    r="45"
                    stroke="#AD8B19"
                    strokeWidth="5"
                    fill="none"
                    strokeDasharray="282.6" // Circumference of the circle (2 * π * 45)
                    strokeDashoffset={(282.6 * (100 - percentage)) / 100}
                    transform="rotate(-90 50 50)" // Rotates the circle to start from the top
                />
            </svg>
            <div className="timer-text">
                {timeLeft}s
            </div>
        </div>
    );
};

export default CircularTimer;
